import { Flex, useMantineTheme } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Radios } from '@feathr/components';

import FormSelect from '../../FormSelect';

type TFormSelection = 'any' | 'specific';

function FormSubmissionGoal(): JSX.Element {
  const { t } = useTranslation();
  const [selectMode, setSelectMode] = useState<TFormSelection>('any');
  const [selectedForms, setSelectedForms] = useState<string[]>([]);
  const {
    spacing: { '4': gap },
  } = useMantineTheme();

  function handleSelectMode(value?: string): void {
    if (!value) {
      return;
    }
    setSelectMode(value as TFormSelection);
  }

  const options = [
    { id: 'any', name: 'Any form submission' },
    { id: 'specific', name: 'Submissions on specific form(s)' },
  ];

  function handleFormSelection(value?: string[]): void {
    if (!value) {
      return;
    }
    setSelectedForms(value);
  }

  return (
    <Flex direction={'column'} gap={gap}>
      <Radios
        helpText={t('Choose which form submissions will be tracked as conversions.')}
        label={t('Form selection')}
        layout={'block'}
        onChange={handleSelectMode}
        options={options}
        value={selectMode}
      />
      {selectMode === 'specific' && (
        <FormSelect
          // TODO: Fix issue with "date_created" ordering when integrating this with predicates.
          filters={{ state: 'published' }}
          isMulti={true}
          label={t('Form(s)')}
          onChange={handleFormSelection}
          placeholder={t('Start typing to search forms')}
          showLastModified={true}
          value={selectedForms}
        />
      )}
    </Flex>
  );
}

export default observer(FormSubmissionGoal);
